import React from 'react';
import PropTypes from 'prop-types';

import { useBrand } from '../Provider/BrandProvider';

const IsometricIcon = ({ icons, size = 'medium', ...props }) => {
  const brand = useBrand();
  const Icon = icons[brand] ? icons[brand] : icons.ED;
  return <Icon size={size} {...props} />;
};

IsometricIcon.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  viewBox: PropTypes.string,
};

export default IsometricIcon;
